import { useLocation } from 'react-router';
import '../../styles/navBar.scss';
import logout from '../../helpers/logout';
import { useContext } from 'react';
import UserContext from '../../context/userContext';
import { useNavigate } from 'react-router';
import { ChakraNav } from './ChakraNav';

const Nav = ({ rol, moroso }) => {
  const { setUser } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  const url = location.pathname;
  const selectedRoute = (currentRoute) => {
    return url === currentRoute
      ? 'btn btn-outline-light nav-pills nav-link active sub-nav px-4'
      : 'sub-nav';
  };

  /* function stringTitleCase(_string) {
		let capitalizeLetterFunc = (match) => match.toUpperCase()
		return _string.replace(/(^\w{1})|(\s{1}\w{1})/g, capitalizeLetterFunc)
	} */

  const handleLogout = async () => {
    try {
      const res = await logout();
      if (res.status === 200) {
        setUser(null);
        return navigate('/');
      }
    } catch (err) {
      //console.log(err);
    }
  };

  if (rol === 'ADMIN') {
    return (
      <ChakraNav
        type="admin"
        handleLogout={handleLogout}
      />
    );
  }

  if (rol === 'TITULAR') {
    return (
      <ChakraNav
        type="titular"
        handleLogout={handleLogout}
        moroso={moroso}
      />
    );
  }

  if (rol === 'POST') {
    return (
      <ChakraNav
        type="post"
        handleLogout={handleLogout}
      />
    );
  }
};

export default Nav;
